import React from "react";
import css from "../../css/agents/filters.module.css";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import FilterCollapse from "./FilterCollapse";
import Checkbox from "./FilterFields/Checkbox";
import Radio from "./FilterFields/Radio";
import Text from "./FilterFields/Text";
import PriceRange from "./FilterFields/PriceRange";
import Location from "./FilterFields/Location";
import Stars, { getLabelFromRating } from "../form/Stars";
import MagnifyIcon from "../../static/icons/magnify.svg";
import {
    AGENT_TYPES,
    AGENT_LANGUAGES,
    AGENT_SPECIALITIES,
    GENDERS,
} from "../../service/agent";

const Filters = (props) => {
    const handleChange = (name, value, submit = true) => {
        if (name === "name" && value && value.value.length === 1) {
            return;
        }

        props.onChange(name, value, submit);
    };

    const { open, values, onSubmit } = props;

    const isOpen = open === true || open === null;

    return (
        <form className={isOpen ? css.formOpen : css.form} onSubmit={onSubmit}>
            <div className={css.input}>
                <label htmlFor="auto_suggest_id">Where</label>
                <Location
                    name="location"
                    value={values.location}
                    onChange={(value) => handleChange("location", value)}
                />
            </div>

            <div className={css.input}>
                <label htmlFor="name">Name</label>
                <Text
                    id="name"
                    name="name"
                    value={values.name}
                    onChange={(value) => handleChange("name", value)}
                />
            </div>

            <button type="submit" className={css.submit}>
                <MagnifyIcon /> Search
            </button>

            {isOpen && (
                <>
                    <FilterCollapse title="Show">
                        <div>
                            <Radio
                                name="type"
                                options={AGENT_TYPES}
                                value={values.type}
                                onChange={(value) =>
                                    handleChange("type", value)
                                }
                            />
                        </div>
                    </FilterCollapse>

                    <FilterCollapse title="Specialities">
                        <div className={css.scroll}>
                            <PerfectScrollbar component="div">
                                <Checkbox
                                    name="speciality"
                                    options={AGENT_SPECIALITIES}
                                    value={values.specialities}
                                    onChange={(value) =>
                                        handleChange("specialities", value)
                                    }
                                />
                            </PerfectScrollbar>
                        </div>
                    </FilterCollapse>

                    <FilterCollapse title="Min Rating">
                        <div className={css.rating}>
                            <div className={css.ratingIcons}>
                                <Stars
                                    name="rating"
                                    value={values.rating}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className={css.ratingValue}>
                                {getLabelFromRating(values.rating.value)}
                            </div>
                        </div>
                    </FilterCollapse>

                    <FilterCollapse title="Price range">
                        <div className={css.priceRange}>
                            <PriceRange
                                name="price_range"
                                priceRange={values.price_range}
                                onChange={(value) =>
                                    handleChange("price_range", value)
                                }
                            />
                        </div>
                    </FilterCollapse>

                    <FilterCollapse title="Languages">
                        <div className={css.scroll}>
                        <PerfectScrollbar component="div">
                                <Checkbox
                                    name="language"
                                    options={AGENT_LANGUAGES}
                                    value={values.languages}
                                    onChange={(value) =>
                                        handleChange("languages", value)
                                    }
                                />
                            </PerfectScrollbar>
                        </div>
                    </FilterCollapse>

                    <FilterCollapse title="Gender">
                        <div>
                            <Radio
                                name="gender"
                                options={GENDERS}
                                value={values.gender}
                                onChange={(value) =>
                                    handleChange("gender", value)
                                }
                            />
                        </div>
                    </FilterCollapse>
                </>
            )}
        </form>
    );
};

Filters.propTypes = {
    values: PropTypes.object.isRequired,
    open: PropTypes.bool || null,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default Filters;
